import React, { useContext, useEffect } from "react"
import { connect } from "react-redux"
import { StyleSheet, View } from "react-native"
import * as amplitude from "@amplitude/analytics-react-native"
import { CongratsTemplate } from "@common/templates/CongratsTemplate"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext, IS_WEB } from "@common/utils/mobileUtils"
import { apiRequest } from "@data/redux/actions/api"
import { useGetFastTrackUserOnMount } from "../fast-track/hooks/useGetFastTrackUserOnMount"
import { StageRecapCard } from "./v2/components/StageRecapCard"
import DownloadAppButton from "../student/tutoring/DownloadAppButton"

const TRACKING_SOURCE = "parent_onboarding.stage_success"

const StagePaymentSuccessScreen = (props) => {
    // The 1€ Stripe pre-inscription flow redirects to this screen without a
    // `user` param. When absent, we skip the pricing fetch and show the
    // minimal confirmation (no recap, no app CTA payload dependencies).
    const hasUserParam = !!props.route?.params?.user
    const { initialLoading, subscriptionMetadata } =
        useGetFastTrackUserOnMount(props)

    const dimensions = useContext(DimensionsContext)
    const hasStageInfo =
        hasUserParam && subscriptionMetadata?.holiday_courses?.length > 0

    useEffect(() => {
        amplitude.track(`${TRACKING_SOURCE}.screen_view`, {
            has_user_param: hasUserParam,
        })
    }, [hasUserParam])

    return (
        <CongratsTemplate
            isLoading={hasUserParam && initialLoading}
            error={hasUserParam ? props.errorRetrieveUser : null}
            title="Bravo ! L'inscription au stage est confirmée"
            description="Le stage est la première étape de l'aventure. Préparons-le ensemble."
        >
            <View
                style={[
                    styles.container,
                    { width: Math.min(dimensions?.width ?? 600, 600) },
                ]}
            >
                {hasStageInfo ? (
                    <StageRecapCard
                        schoolSubjects={props.schoolSubjects}
                        holidayCourses={props.holidayCourses}
                        subscriptionMetadata={subscriptionMetadata}
                    />
                ) : null}

                {IS_WEB ? (
                    <View style={styles.downloadBlock}>
                        <TextM
                            fontSize={20}
                            fontWeight="Bold"
                            color={theme.colors.primary}
                            style={styles.centered}
                            wrap
                        >
                            Téléchargez l'app parent pour suivre le stage
                        </TextM>
                        <TextM
                            fontSize={15}
                            color={theme.colors.grey}
                            style={styles.centered}
                            wrap
                        >
                            Recevez les informations pratiques du stage,
                            échangez avec le tuteur et suivez la progression de
                            votre enfant en temps réel.
                        </TextM>
                        <View style={styles.badges}>
                            <DownloadAppButton
                                trackingSource={TRACKING_SOURCE}
                            />
                        </View>
                    </View>
                ) : null}
            </View>
        </CongratsTemplate>
    )
}

const styles = StyleSheet.create({
    container: {
        alignSelf: "center",
        gap: 30,
        paddingHorizontal: 10,
    },
    downloadBlock: {
        alignItems: "center",
        gap: 10,
    },
    centered: {
        textAlign: "center",
    },
    badges: {
        alignItems: "center",
    },
})

const mapStateToProps = (state) => ({
    holidayCourses: state.data.formData?.holidayCourses,
    schoolSubjects: state.data.formData?.schoolSubjects,
    errorRetrieveUser: state.api.getSubscribePricing?.error,
})

const mapDispatchToProps = {
    apiRequest,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StagePaymentSuccessScreen)
